// eslint-disable-next-line no-shadow
export enum CurrentPlan {
	FREE = 'free',
	PRIVILEGED = 'privileged',
	PRO = 'pro',
	MAX = 'max',
	ULTRA = 'ultra',
	ELITE_PLUS_PLUS = 'elite++',
}
